import React from 'react'

export const TableCellYesNo = ({
  isYesNo,
}: {
  isYesNo: number | string
}): React.ReactElement => {
  return <>{isYesNo === 1 ? 'Yes' : 'No'}</>
}
